// client/src/components/PrescriptionSetting/PrescriptionSetting.jsx
import React, { useCallback, useEffect, useState } from 'react'
import Menu from '../Menu/Menu';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid';
import { Box, Typography, Button } from '@mui/material';
import api from '../../utils/axios.secure';

function PrescriptionSetting() {
  const [prescriptionList, setPrescriptionList] = useState([]);
  const [filterText, setFilterText] = useState('');

  const navigate = useNavigate();

  const selectPrescriptionList = useCallback(async () => {
    try {
      const { data: res } = await api.post('/manager/user/userList');
      const payload = res?.data || res;
      if (payload?.status) {
        setPrescriptionList(Array.isArray(payload.data) ? payload.data : []);
      } else {
        alert('?곗씠?곕? 媛?몄삤?????ㅽ뙣?덉뒿?덈떎.');
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      alert('?쒕쾭 ?ㅻ쪟媛 諛쒖깮?덉뒿?덈떎.');
    }
  }, [])
  /*
    fetch('https://ser.inthenews.p-e.kr/api/manager/user/userList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_num: matching,
      }),
    })
      .then((res) => res.json())
      .then(({ data }) => {
        if (data.status) {
          setPrescriptionList(data.data)
          console.log(data.data)
        } else {
          alert('데이터를 가져오는 데 실패했습니다.');
        }
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        alert('서버 오류가 발생했습니다.');
      });
  }, [])
  */

  function CustomToolbarWithEncoding({ rows, columns }) {
    const handleExportWithEncoding = () => {
      const csvData = [];
      const headers = columns.map((col) => col.headerName).join(','); // 헤더
      csvData.push(headers);

      rows.forEach((row) => {
        const rowData = columns.map((col) => row[col.field] || '').join(',');
        csvData.push(rowData);
      });

      // BOM 추가
      const csvContent = '\uFEFF' + csvData.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // 파일 다운로드
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'data.csv');
      link.click();
    };

    return (
      <GridToolbarContainer>
        {/* <GridToolbarExport csvOptions={{ disableToolbarButton: true }} /> */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleExportWithEncoding}
          sx={{ margin: '3px', marginBottom: '8px', display: 'block', marginLeft: 'auto' }}
        >내보내기</Button>
      </GridToolbarContainer>
    );
  }

  const columnTitles = {
    idx: '순번',
    user_num: '이름',
  };

  const getMaxCustomerLength = () => {
    let maxLength = 0;
    prescriptionList.forEach((item) => {
      const customerLength = item.description ? item.description.length : 0;
      if (customerLength > maxLength) {
        maxLength = customerLength;
      }
    });
    return maxLength;
  };

  const keys = Object.keys(columnTitles);
  const maxCustomerLength = getMaxCustomerLength();
  const customerColumnWidth = maxCustomerLength * 10; // 글자 하나의 예상 폭 (단위는 px)

  const columns = keys.map(key => ({
    field: key,
    headerClassName: 'datagrid-header',
    headerName: columnTitles[key],
    flex: 1,
    headerAlign: 'center',
    // width: key === 'description' ? customerColumnWidth : 150,
    editable: true, // 모든 열을 편집 가능하게 설정
  }));

  const filteredRows = prescriptionList.filter((item) =>
    keys.some((key) => {
      const value = item[key] ? item[key].toString().toLowerCase() : '';
      return value.includes(filterText.toLowerCase());
    })
  ).map((item, index) => ({
    id: index,
    ...item,
  }));

  const handleDetailClick = (params) => {
    const paramsName = params.row.user_num
    navigate(`/dps/${paramsName}`);
  };

  useEffect(() => {
    selectPrescriptionList();
  }, [selectPrescriptionList]);

  return (
    <Menu>
      <Box sx={{
        float: 'left',
        width: 'calc(100% - 260px)',
        minWidth: '98%',
        marginTop: '30px',
        marginLeft: '10px',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        padding: '10px 2px',
      }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <Typography sx={{ marginLeft: '30px' }} variant="h4" component="h2" gutterBottom>
            처방
          </Typography>
          <input
            type="text"
            placeholder="검색어를 입력하세요"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            style={{ padding: '5px', width: '500px', height: '40px' }}
          />
        </Box>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={10}
          onRowClick={handleDetailClick}
          style={{ height: '85%', width: '100%' }}
          onProcessRowUpdateError={(error) => {
            console.error('Error updating row:', error);
          }}
          slots={{
            toolbar: () => <CustomToolbarWithEncoding rows={filteredRows} columns={columns} />,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '1.6rem', // 헤더 글자 크기 조절
              justifyContent: 'center', // Flexbox를 사용해 텍스트 가운데 정렬  
            },
            '& .MuiDataGrid-columnHeader': {
              borderRight: '1px solid #ccc', // 컬럼 사이 구분선
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              textAlign: 'center', // 헤더 텍스트 가운데 정렬 보조
              width: '100%', // Flexbox와 함께 사용할 때 폭 지정
            },
            '& .datagrid-header': {
              backgroundColor: 'rgba(30, 120, 250, 1)',
              color: '#fff', // 헤더 텍스트 색상
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'rgba(30, 120, 250, 1)',
              color: '#fff',
            },
            '& .MuiDataGrid-cell': {
              fontSize: '1.5rem', // 셀 글자 크기 조절
              justifyContent: 'center', // 셀 내용 가운데 정렬
              display: 'flex', // 내용 정렬을 위해 flex 사용
              alignItems: 'center',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
              display: 'none', // 스크롤 바 숨기기
            },
            '& .MuiTablePagination-select': {
              display: 'none'
            },
            '& .MuiTablePagination-selectLabel': {
              display: 'none'
            },
            '& .MuiTablePagination-actions': {
              fontSize: '1.8rem',
              marginRight: '15px'
            },
            '& .MuiTablePagination-displayedRows': {
              fontSize: '1.4rem', // 페이지 표시 폰트 크기 조정
            },
          }}
        />
      </Box>
    </Menu>
  )
}

export default PrescriptionSetting
